module.exports = __webpack_public_path__ + "img/zgyh-icon.6b962a75.png";